import { render, staticRenderFns } from "./DuplicarImovelDialog.vue?vue&type=template&id=62363c8d&"
import script from "./DuplicarImovelDialog.vue?vue&type=script&lang=js&"
export * from "./DuplicarImovelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports